export default "__VITE_PUBLIC_ASSET__b6339bb1__"